import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderChat from './CommonHeaderChat';
import Search from '../../../components/Search';
import CommonHeaderRight from './CommonHeaderRight';
import DelegationBanner from '../../presentation/Delegation/DelegationBanner';

const DashboardHeader = () => {
	return (
		<Header>
			<HeaderLeft>
				<Search />
				<DelegationBanner />
			</HeaderLeft>
			{/* <CommonHeaderRight afterChildren={<CommonHeaderChat />} /> */}
			<CommonHeaderRight />
		</Header>
	);
};

export default DashboardHeader;
